import { render, staticRenderFns } from "./SupplierOnboardingFinishMessage.vue?vue&type=template&id=196190e3&"
import script from "./SupplierOnboardingFinishMessage.vue?vue&type=script&lang=js&"
export * from "./SupplierOnboardingFinishMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports